import React,{useRef} from "react";
import ExpenseSingle from "./singleView/View";

function InvoiceSingle()  {
    const componentRef = useRef(0);
   
    return(
       <div className="react-outeroi" ref={componentRef}>
            <ExpenseSingle />
        </div>
    )

}

export default InvoiceSingle;